<template>
  <div class="level">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{$t('m.jl_span1')}}</p>
    </div>
    <div class="level_con">
      <list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="getData"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          class="record-item"
        >
          <div class="record-main">
            <icon
              name="balance-list-o"
              class="record-icon"
              size="22"
              color="#1769b0"
            />
            <div class="record-info">
             <div class="record-title">充值记录 · {{ item.id }}</div>
              <div v-if="displayRemark(item.remark)" style="margin-bottom: 5px">
                {{$t('m.jf_span7')}}：{{ displayRemark(item.remark) }}
              </div>
              <div style="margin-bottom: 5px">{{$t('m.jl_span3')}}：{{ item.reply }}</div>
              <div style="color: #969799; font-size: 12px;">
                {{ createDate(item.created_at) }}
              </div>
            </div>
          </div>
          <div class="record-status">
            <div>{{ item.money }} USD</div>
            <div>
              <span v-if="item.status === 0">{{$t('m.jl_span4')}}</span>
              <span v-if="item.status === 1">{{$t('m.jl_span5')}}</span>
              <span v-if="item.status === 2">{{$t('m.jl_span6')}}</span>
              <span v-if="item.status === 3">{{$t('m.jl_span7')}}</span>
            </div>
          </div>
        </div>
      </list>
    </div>
  </div>
</template>

<script>
import { getRecharge } from "../../../api/user";
import Icon from "vant/lib/icon";
import List from "vant/lib/list";
import "vant/lib/list/style";
export default {
  name: "index",
  components: {
    Icon,
    List
  },
  data() {
    return {
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      show: false,
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  methods: {
    displayRemark(remark) {
      const text = String(remark || "").trim();
      if (!text || this.isProofPath(text)) {
        return "";
      }
      return text;
    },
    isProofPath(text) {
      return /(?:^|\/)storage\/recharge\/.+\.(jpg|jpeg|png|gif|webp|bmp)(\?.*)?$/i.test(
        text
      );
    },
    getData() {
      getRecharge({ page: this.page }).then(res => {
        console.log(res.data.data);
        if (res.data.data.length > 0) {
          this.list = this.list.concat(res.data.data);
          this.page++;
        } else {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    }
  }
};
</script>

<style scoped>
.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: relative;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
}
.level_con {
  padding: 20px 15px;
}
.record-item {
  background-color: #ffffff;
  padding: 15px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(40, 79, 119, 0.07);
  border-radius: 14px;
  box-shadow: 0 9px 24px rgba(20, 53, 88, 0.065);
}
.record-main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
}
.record-info {
  min-width: 0;
  line-height: 1.35;
  word-break: break-word;
}
.record-status {
  flex: 0 0 auto;
  max-width: 120px;
  margin-left: 12px;
  color: #31465f;
  text-align: right;
  word-break: break-word;
}
.record-status > div:first-child {
  margin-bottom: 5px;
  color: #1769b0;
  font-size: 13px;
  font-weight: 700;
}
.record-title {
  margin-bottom: 6px;
  color: #23364d;
  font-size: 13px;
  font-weight: 650;
}
.record-icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  margin-right: 10px;
  place-items: center;
  background: #e9f3fb;
  border-radius: 11px;
}
</style>

